import React, { useEffect, useState } from 'react';
import { analyticsUserTrack } from '../config/analyticsTrack';
import Logo from './assets/logo.png'
import Config from '../helper/Config';
import { Link } from 'react-router-dom';
import bg from './assets/bg_v2.png'
import "./Custom.css"
import Footer from './Footer';
import Header from './components/Header';

export default function Home(props) {
    const [showMenu, setShowMenu] = useState(false);


    useEffect(() => {

        analyticsUserTrack("Home", "Landing");
        const handleScroll = () => {
            const scrollTop = window.scrollY;
            const shouldShow = scrollTop > 150;

            setShowMenu((prev) => {
                if (prev !== shouldShow) {
                    return shouldShow;
                }
                return prev;
            });
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);

    }, [])

    return <div className='may-2025 home'>
        <div className='block1' style={{ marginTop: 0 }}>
            <div className={`home-sticky-crop home ${showMenu ? "home-sticky-background" : ""}`} style={{ top: 0 }}>
                <Link to={Config.projectUrl + "/"} onClick={() => window.scrollTo(0, 0)}>
                    <img className='logo' src={Logo} />
                </Link>
                {
                    showMenu && <Header />
                }
            </div>
        </div>
        <div className="full-screen-image">
            <img className='img-fluid bg' src={bg} alt="GHT" />
            {/* <img className='bg-logo' src={Logo}></img> */}
            <div className='bg-text montserrat-font-family'>
                Solving Global Challenges <br /> with Meaningful Connectivity
                <div className='sub-text my-3'>
                    From local communities to global networks,we build digital ecosystems <br />
                    with velocity for scalability and sustainability
                </div>
            </div>
        </div>
        <div className=''>

            <div className='teq-difference'>
                <div className='heading-text montserrat-font-family text-center'>
                    The Teqbahn Difference
                </div>
                <div className='my-5 sub-text'>
                    <div className='row'>
                        <div className='col-sm-3' />
                        <div className='col-sm-3'>
                            <div>
                                <b className='montserrat-font-family'>Challenge</b>
                                <div className='my-3'>
                                    <ul style={{ padding: "0 15px" }}>
                                        <li>High-cost tech</li>
                                        <li>Infrastructure gaps</li>
                                        <li>Climate burden</li>
                                        <li>AI access disparity</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className='col-sm-6 teqbahn-solution'>
                            <b className='montserrat-font-family'>Teqbahn's Solution</b>

                            <div className='my-3'>
                                <ul style={{ padding: "0 15px" }}>
                                    <li>Carbon-sensitive, modular infrastructure</li>
                                    <li>Full stack platforms to Web-lite + USSD + SMS capabilities</li>
                                    <li>Advanced edge computing to reduce digital emissions</li>
                                    <li>Agentic systems that are localized</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className='our-vision text-center'>
            <div className='container'>
                <div className='heading-text montserrat-font-family'>
                    Our Vision
                </div>
                <div className='my-5 sub-text'>
                    Teqbahn is shaping a future where technology amplifies human potential, where connectivity is both meaningful and equitable, <br />
                    and where the digital world becomes more sustainable and secure for all.
                </div>
            </div>
        </div>
        <Footer />
    </div>;
}
